// eslint-disable-next-line no-restricted-imports -- the branded parser that wraps parseISO for every other file
import { parseISO } from 'date-fns/parseISO'
import { isValidDate } from 'lib/helpers/isValidDate/isValidDate'

/**
 * Parses an ISO 8601 string into the value it names: a calendar day becomes a floating date at local
 * midnight, a timestamp becomes the instant it points at. Returns `null` for an empty or unparseable string.
 */
export const parseDateFromISO = (date?: Maybe<ISODate | ISODateTime>): Date | null => {
  if (!date) {
    return null
  }

  const parsedDate = parseISO(date)

  return isValidDate(parsedDate) ? parsedDate : null
}
